/**
 * @param {import("axios").AxiosInstance} instance
 */

export default function auth(instance) {
	return {
		/**
		 * @param {{
		 *  email: string,
		 *  password: string
		 * }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		login: (body, config = {}) => {
			return instance.post('auth/login', body, config)
		},

		/**
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		logout: (config = {}) => {
			return instance.post('auth/logout', null, config)
		},

		/**
		 * @param {{
		 *  userId: guid,
		 *  token: string
		 * }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		tokenRefresh: (body, config = {}) => {
			return instance.post('auth/refresh', body, config)
		}
	}
}
